<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">盘点物品选择</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <div>
                    <el-row style="float: left;margin:10px 0">
                        <el-input  placeholder="请输入物品名称" v-model="name" clearable style="width:200px"></el-input>
<!--                        <el-select v-model="warehouseCode" placeholder="请选择仓库" clearable style="margin:0 5px;width:200px;">-->
<!--                            <el-option-->
<!--                                    v-for="item in warehouseCodeValue"-->
<!--                                    :key="item.warehouseCode"-->
<!--                                    :label="item.name"-->
<!--                                    :value="item.warehouseCode">-->
<!--                            </el-option>-->
<!--                        </el-select>-->
<!--                        <el-select v-model="supplierCode" placeholder="请选择供应商" clearable style="margin:0 5px;width:200px;">-->
<!--                            <el-option-->
<!--                                    v-for="item in SupplierCodeValue"-->
<!--                                    :key="item.supplierCode"-->
<!--                                    :label="item.name"-->
<!--                                    :value="item.supplierCode">-->
<!--                            </el-option>-->
<!--                        </el-select>-->
<!--                        <el-select v-model="waresTypeCode" placeholder="请选择物品类型" clearable style="margin:0 5px;width:200px;">-->
<!--                            <el-option-->
<!--                                    v-for="item in WaresTypeCodeValue"-->
<!--                                    :key="item.waresTypeCode"-->
<!--                                    :label="item.name"-->
<!--                                    :value="item.waresTypeCode">-->
<!--                            </el-option>-->
<!--                        </el-select>-->
<!--                        <el-select v-model="status" placeholder="选择物品状态" style="margin:0 5px;width:200px;">-->
<!--                            <el-option-->
<!--                                    v-for="item in status2"-->
<!--                                    :key="item.value"-->
<!--                                    :label="item.label"-->
<!--                                    :value="item.value">-->
<!--                            </el-option>-->
<!--                        </el-select>-->
                        <el-button style="margin-left:10px" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </el-row>
                    <div style="clear: both;"></div>
                </div>
                 <template>
                <el-table :data="tableData" height="200" border v-loading="loading">

                    <el-table-column prop="name" label="物品名称"></el-table-column>

                    <el-table-column prop="supplierName" label="供应商"></el-table-column>

                    <el-table-column prop="waresTypeName" label="物品类型"></el-table-column>

                    <el-table-column prop="stock" label="库存"></el-table-column>

                    <el-table-column
                            prop="Status"
                            :formatter="statusTitle"
                            label="状态">
                    </el-table-column>

                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="primary" v-if="scope.row.add==0" size="small" @click="handleSelect(scope.$index, scope.row)">选择</el-button>
                            <el-button type="success" v-if="scope.row.add==1" size="small">已添加</el-button>
                        </template>
                    </el-table-column>

                </el-table>
                <div style="text-align: left;background-color: #fff;padding: 10px;">
                    <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                    <div style="float: left;">
                        <el-pagination
                                background
                                layout="prev, pager, next"
                                :total="totalItems"
                                :page-size="20"
                                @current-change="current_change">
                        </el-pagination>
                    </div>
                    <div style="clear: both;"></div>
                </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,getTokenBykey} from "@/utils/auth";

    export default {
        name: "Add",
        data() {
            return {

                loading: true,
                add_waresCode:'',
                pageSize:20,
                currentPage:1,
                showModalAdd:false,
                tableData:[],
                waresList:[],
                totalItems: 0,
                th:0,
                status:-1,
                SupplierCodeValue:[],
                WaresTypeCodeValue:[],
                warehouseCodeValue:[],
                supplierCode:'',
                waresTypeCode:'',
                warehouseCode:'',
                status2: [{
                    value: -1,
                    label: '所有状态'
                },{
                    value: 0,
                    label: '正常'
                }, {
                    value: 1,
                    label: '禁用'
                }],
                name:'',
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    address:'',
                },

                rules:{
                    name:[
                        { required: true, message: '物品名称', trigger: 'blur' },
                    ],
                    sort:[
                        { required: true, message: '请输入库存', trigger: 'blur' },
                        { type: 'number', message: '库存必须为数字值'}
                    ],
                }


            }
        },

        methods: {
            init(){

              this.$axios({
                method: 'post',
                url: this.$shopUrl+"Warehouse/List",
                data: {
                  timeStr: timeStr,
                  sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                  staffCode: getStaffCode(),
                }
              }).then(
                  (response) => {
                    if (response.data.error == 0) {
                      this.warehouseCodeValue = response.data.data;
                    }else if(response.data.error == 1){
                      this.$message({type: 'info', message: response.data.message});
                    }
                  }
              )
              this.$axios({
                method: 'post',
                url: this.$shopUrl+"Supplier/List",
                data: {
                  timeStr: timeStr,
                  sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                  staffCode: getStaffCode(),
                }
              }).then(
                  (response) => {
                    if (response.data.error == 0) {
                      this.SupplierCodeValue = response.data.data;
                    }else if(response.data.error == 1){
                      this.$message({type: 'info', message: response.data.message});
                    }
                  }
              )
              this.$axios({
                method: 'post',
                url: this.$shopUrl+"WaresType/List",
                data: {
                  timeStr: timeStr,
                  sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                  staffCode: getStaffCode(),
                }
              }).then(
                  (response) => {
                    if (response.data.error == 0) {
                      this.WaresTypeCodeValue = response.data.data;
                    }else if(response.data.error == 1){
                      this.$message({type: 'info', message: response.data.message});
                    }
                  }
              )
                this.getList();

            },
            closeSelf() {
                this.$emit("closeSelectWares");
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            handleSelect(index,row){
                var list=getTokenBykey(getStaffCode()+'waresInfoInventory');
                list?list=JSON.parse(list):list=[]
                if(this.isAdd(row.waresCode,list)){
                    this.$prompt('请输入此物品盘点数量', '商品数量', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputPattern:/^(0|\+?[1-9][0-9]*)$/,
                        inputErrorMessage:'添加数量为正整数',
                        inputType:'number'
                    }).then(({ value }) => {
                        row.inventoryCount=value
                        this.$emit("getWares",row);
                        this.tableData=this.getData(this.tableData)
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '取消输入'
                        });
                    });
                }else{
                    this.$message({
                        type: 'info',
                        message: '此物品已添加'
                    });
                }
            },
            isAdd(code,list){
                for(var i in list){
                    if(list[i].waresCode==code){
                        return false;
                    }
                }
                return true
            },
            changeWares(selVal){
                this.add_waresCode=selVal;
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },
            getList(){
                this.loading=true;
                var supplierCode=this.supplierCode;
                var waresTypeCode=this.waresTypeCode;
                var warehouseCode=this.warehouseCode;
                if(!supplierCode){
                    supplierCode='00000000-0000-0000-0000-000000000000'
                }
                if(!waresTypeCode){
                    waresTypeCode='00000000-0000-0000-0000-000000000000'
                }
                if(!warehouseCode){
                    warehouseCode='00000000-0000-0000-0000-000000000000'
                }
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+'Wares/Page',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        waresTypeCode:waresTypeCode,
                        supplierCode:supplierCode,
                        warehouseCode:warehouseCode,
                        name:this.name,
                        status:this.status,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then((response)=> {
                    this.loading=false;
                    if(response.data.error == 0){
                        var data= response.data.data.list;
                        this.tableData=this.getData(data)
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message(response.data.message);
                    }else{
                        console.log(response.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getData(data){
                var waresInfoInventory=getTokenBykey(getStaffCode()+'waresInfoInventory');
                for(var i in data){
                    if(waresInfoInventory){
                        if(!this.isAdd(data[i].waresCode,JSON.parse(waresInfoInventory))){
                            data[i].add=1
                        }else{
                            data[i].add=0
                        }
                    }else{
                        data[i].add=0
                    }
                }
                console.log(data)
                return data
            }
        }
    }
</script>

<style  lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

    .modal {
        background-color: #fff;
        box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        overflow-x:auto;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        width:680px;

    .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: space-between;
        padding: 10px;
        display: flex;
    }
    .modal-body {
        position: relative;
        padding: 20px 20px 0;
        z-index: 99;
        height: 100%;
    }
    .modal-footer {
        border-top: 1px solid #eee;
        justify-content: flex-end;
        padding: 15px;
        display: flex;
    }


    }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }
</style>
